import { InjectionToken } from '@angular/core';
import { IBillingMockService } from './billing-mock.interface';

// Angular DI token for the billing service. Real implementation later swaps the
// provider behind this token to a real BillingApiService.
export const BILLING_SERVICE = new InjectionToken<IBillingMockService>('BILLING_SERVICE');
